import React from 'react'
import { Stack, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

export interface AppDrawerMetadataRowProps {
  label: string
  value?: React.ReactNode
  mono?: boolean
  /** Width of the label column. Defaults to 76px (compact metadata strip). */
  labelWidth?: number
  sx?: SxProps<Theme>
}

const AppDrawerMetadataRow: React.FC<AppDrawerMetadataRowProps> = ({
  label,
  value,
  mono = false,
  labelWidth = 76,
  sx,
}) => (
  <Stack
    direction="row"
    spacing={1.25}
    alignItems="flex-start"
    sx={[{ minHeight: 18 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
  >
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        width: labelWidth,
        flexShrink: 0,
        fontWeight: 600,
        fontSize: '0.65rem',
        letterSpacing: 0.4,
        textTransform: 'uppercase',
        lineHeight: 1.6,
      }}
    >
      {label}
    </Typography>
    {typeof value === 'string' || value == null ? (
      <Typography
        variant="caption"
        sx={{
          fontFamily: mono ? 'ui-monospace, SFMono-Regular, monospace' : undefined,
          fontSize: '0.75rem',
          color: 'text.primary',
          wordBreak: 'break-all',
          minWidth: 0,
          flex: 1,
        }}
      >
        {value || '-'}
      </Typography>
    ) : (
      value
    )}
  </Stack>
)

export default AppDrawerMetadataRow
